import controller from './select-field-controller';
import template from './select-field.html';

const SelectFieldComponent = {
    bindings: {
        displayProp: '<',
        fieldName: '<',
        hideLabel: '<',
        inputClass: '<',
        itemList: '<',
        label: '<',
        labelClass: '<',
        parentForm: '<',
        isRequired: '<',
        selectedItem: '<',
        setItem: '&'
    },
    controller,
    template
};

export default SelectFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/select-field/select-field-component.js